import { photoApi } from '@/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const usePhotoUpdate = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: photoApi.updatePhoto,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['photo-upload'] });
        },
        onError: (error) => {
            console.error('Error updating user data:', error);
        },
    });

    return mutation;
};
